import React, { useState } from "react";
import { Box, Table, Thead, Tbody, Tr, Th, Td, Button, Spinner, Text, Select } from '@chakra-ui/react';
import { deleteBeneficiaryData, deleteUserData } from "./ManageUserFun";
import { MdDelete } from "react-icons/md";

export const UserDataTable: React.FC<any> = ({ data, searchRef, page, limit, handlePage, handleLimit, totalPages }) => {
    const [isLoading, setIsLoading] = useState<null | number>(null)

    const deleteUserDataHandle = async (item: any, ind: number) => {
        setIsLoading(ind)
        let res: boolean;

        const isSelf = item.collection === "Beneficiary"
            ? item?.personalInfo?.relationshipToSubscriber === "Self"
            : true; // Subscriber rows always use the full cascade delete

        if (isSelf) {
            // Full cascade delete: user + subscriber + all beneficiaries
            res = await deleteUserData({ userId: item.userId })
        } else {
            // Single beneficiary delete: only this dependent
            res = await deleteBeneficiaryData(item._id)
        }

        if (res) {
            searchRef.current?.click()
        }
        setIsLoading(null)
    }


    return (
        <Box>
            <Table variant="unstyled" >
                <Thead>
                    <Tr>
                        <Th>Collection</Th>
                        <Th>Name</Th>
                        <Th>Email</Th>
                        <Th>Company</Th>
                        <Th>Beneficiary/Subscriber Id</Th>
                        <Th>User ID</Th>
                        <Th>Relationship To Subscriber</Th>
                        <Th>Delete</Th>
                    </Tr>
                </Thead>
                <Tbody >
                    {data?.map((item: any, ind: number) => {
                        return (
                            <Tr key={item?._id || ind}>
                                <Td>{item.collection}</Td>
                                <Td>{item.collection === "Beneficiary" ? (item.personalInfo?.fullName || "N/A") : (item.name || "N/A")}</Td>
                                <Td>{item.collection === "Beneficiary" ? (item.personalInfo?.email || "N/A") : (item.email || "N/A")}</Td>
                                <Td>{item.collection === "Beneficiary" ? (item.company?.name || "N/A") : (item.company?.name || item.companyName || "N/A")}</Td>
                                <Td>{item?._id}</Td>
                                <Td>{item.userId}</Td>
                                <Td>{item.collection === "Beneficiary" ? (item?.personalInfo?.relationshipToSubscriber || "N/A") : "Self"}</Td>
                                <Td>
                                    <Button bg={"#E2E8F0"} onClick={() => deleteUserDataHandle(item, ind)}
                                        isDisabled={item.isDeleted}
                                    >
                                        {isLoading !== ind && item.isDeleted && "Deleted"}
                                        {isLoading !== ind && item.isDeleted !== true && <MdDelete color="red" />}
                                        {isLoading === ind && <Spinner
                                            thickness='4px'
                                            speed='0.65s'
                                            emptyColor='gray.200'
                                            color='blue.500'
                                            size='md'
                                        />}
                                    </Button>
                                </Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
            <Box display={"flex"} mt={"20px"} gap={"20px"} justifyContent={"center"} ml={"80px"} alignItems={"center"} mb={"20px"}>
                <Button onClick={(e) => handlePage(-1)} isDisabled={page === 1} colorScheme="green">Prev</Button>
                <Text>{`${page}/${totalPages}`}</Text >
                <Button onClick={(e) => handlePage(1)} isDisabled={page === totalPages} colorScheme="green">Next</Button>
                <Select onChange={handleLimit} width={"fit-content"}>
                    <option value={"10"}>10</option>
                    <option value={"50"}>50</option>
                    <option value={"100"}>100</option>
                </Select>
            </Box>
        </Box>
    )
}